import React, { useState } from 'react';
import { Label, Loader, Modal } from '../../../../Components/uielements';
import { IntlMessages } from '../../../../helper/langHelper';
import { getLinks, remove } from '../../../../services/bioplus-services/links';
import {
  ContentWrapper,
  // LinksContainer,
  LinksContainerWithDelete,
  LinksLabel,
  LinksModalWrapper,
  LoaderWrapper,
  Tag,
} from '../dashboard.style';
import {
  // links,
  openLinkInNewTab,
} from '../helper';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { DeleteIcon, EmptyState, LinkSvg } from '../../../../Components/icons';
import AddLinkModal from './addLinkModal';
import { useUserContext } from '../../../../hooks/UserContext';
export const LinksModal = ({ onClose }) => {
  const userContext = useUserContext();
  const roleId = userContext?.company?._id;
  const [openAddLinkModal, setOpenAddLinkModal] = useState(false);
  const query = useQuery(['getLinks'], () => getLinks({ roleId }));
  const queryClient = useQueryClient();

  const role = userContext?.company?.role;

  const deleteMutation = useMutation((id) => remove(id), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('getLinks');
    },
    onError: () => {
      alert('Something went wrong. Please try again later.');
    },
  });

  const handleClicked = (link) => {
    openLinkInNewTab(link);
  };

  const handleOpenAddLinkModal = () => {
    setOpenAddLinkModal(true);
  };
  const handleClosedAddLinkModal = () => {
    setOpenAddLinkModal(false);
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="dashboard.links" />}
        isClosedButton={
          // role !== 'MANAGER' &&
          role !== 'EMPLOYEE' && true
        }
        onOpen={handleOpenAddLinkModal}
      >
        {query.isLoading ? (
          <LinksModalWrapper style={{ margin: '40px 0px' }}>
            <LoaderWrapper>
              <Loader />
            </LoaderWrapper>
          </LinksModalWrapper>
        ) : (
          <LinksModalWrapper>
            {query?.data?.length === 0 && (
              <ContentWrapper>
                <EmptyState />
                <Label>
                  No links are available. Please click the 'Add Link' button to include your links.
                </Label>
              </ContentWrapper>
            )}
            {query &&
              query?.data?.length > 0 &&
              query?.data?.map((link, index) => (
                <LinksContainerWithDelete key={index}>
                  <div style={{ display: 'flex', gap: '20px' }}>
                    <LinkSvg />
                    <LinksLabel onClick={() => handleClicked(link?.link)}>
                      {link?.name !== '' ? link?.name : link?.link}
                      {link?.isPrivate ? <Tag>Private</Tag> : <Tag>Public</Tag>}
                    </LinksLabel>
                  </div>
                  {role?.split('')[0] === link?.linkType &&
                    // role !== 'MANAGER' &&
                    role !== 'EMPLOYEE' && (
                      <DeleteIcon onClick={() => deleteMutation.mutate(link?._id)} />
                    )}
                </LinksContainerWithDelete>
              ))}
            {/* {links?.map((link, index) => (
            <LinksContainer key={index}>
              {link?.icon}
              <LinksLabel onClick={() => handleClicked(link?.link)}>{link?.name}</LinksLabel>
            </LinksContainer>
          ))} */}
            {openAddLinkModal && (
              <AddLinkModal onClose={handleClosedAddLinkModal} isOpen={openAddLinkModal} />
            )}
          </LinksModalWrapper>
        )}
      </Modal>
    </>
  );
};

export default LinksModal;
